import { getServerSideProps as _getServerSideProps } from '../../productos';

export { default } from '../../productos';

export async function getServerSideProps(ctx) {
  return _getServerSideProps(ctx, 'mujer');
}
